import React from 'react'

const BoukMerchantsSecurityofDataandPrivacyPolicy = () => {
  return (
    <div>
      <p className="s1" style={{paddingTop: '3pt', paddingLeft: '140pt', textIndent: '0pt', lineHeight: '153%', textAlign: 'center'}}>
          Security of Data and Privacy Policy<span className="h1"> </span>United States
        </p>
        <p className="s1" style={{paddingLeft: '140pt', textIndent: '0pt', textAlign: 'center'}}>
          Bouk Merchants
        </p>
        <h1 style={{paddingTop: '8pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify'}}>
          Before you use the products and services, please read these terms
          carefully. By executing the agreement or master agreement (herein referred
          to as “agreement”) with Bouk or using the services, platform, and/or
          products, you, and any entities that you represent and all your
          franchisees and/or affiliates (if any) ("you" or
          "merchant") agree to be bound by the terms contained herein in
          addition to the terms in the agreement (as defined herein). The terms of
          this agreement apply only to the subject matter herein.
        </h1>
        <p style={{textIndent: '0pt', textAlign: 'left'}}><br /></p>
        <p className="s2" style={{paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left'}}>
          SECTION A
        </p>
        <h1 style={{paddingTop: '8pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left'}}>
          DEFINITIONS<span className="p">.</span>
        </h1>
        <ol id="l1">
          <li data-list-text={1.}>
            <h1 style={{paddingTop: '7pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify'}}>
              Personal Data
              <span className="p">- This is information about a recognized or known individual that
                is utilized to determine or track that person (a natural
                person's identity), either alone or in combination with
                additional personal or distinguishing data that is connected or
                associated to that person. Personal Data also includes any
                additional data about a precise individual that is defined as
                Personal Data by the data protection rules prevalent in the
                jurisdictions where that person resides.</span>
            </h1>
          </li>
          <li data-list-text={2.}>
            <h1 style={{paddingTop: '8pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify'}}>
              Process <span className="p">or </span>Processing
              <span className="p">- The recording, utilization, accessibility to, publication,
                storing, transmission, or other handling of Personal Data of any
                private citizen that the discloser permits to use or access a
                service is referred to as this.</span>
            </h1>
          </li>
          <li data-list-text={3.}>
            <h1 style={{paddingTop: '7pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify'}}>
              Systems
              <span className="p">- means a Party’s computer systems or network (including
                third-party systems such as Amazon Web Services) that host, process
                or store the Discloser’s Personal Data.</span>
            </h1>
          </li>
          <li data-list-text={4.}>
            <h1 style={{paddingTop: '8pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify'}}>
              Privacy and Security Laws
              <span className="p">- This refers to U.S. federal, state, and municipal regulations, as
                well as non-U.S. laws, that govern the safety and confidentiality of
                Personal Data and are applicable to Bouk and/or Merchant, as the
                case may be.</span>
            </h1>
          </li>
          <li data-list-text={5.}>
            <h1 style={{paddingTop: '7pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify'}}>
              Security Incident
              <span className="p">- This refers to illegal accessibility to or collection of Personal
                Data held on User's devices, resulting in the breach of Personal
                Data for which Discloser is liable.</span>
            </h1>
          </li>
        </ol>
        <p className="s1" style={{paddingTop: '3pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left'}}>
          SECTION B
        </p>
        <h1 style={{paddingTop: '9pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left'}}>
          PROCESSING PERSONAL DATA<span className="p">.</span>
        </h1>
        <ol id="l2">
          <li data-list-text={1.}>
            <p style={{paddingTop: '8pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify'}}>
              Personal Data can be obtained and then used to deliver, assist, and
              optimize the Services, enforce the Contract and further the
              Merchant-Bouk business relationship, adhere to rules, and act in
              conformity with the Discloser's written instructions or otherwise
              in compliance with the Agreement Terms during the provision and use of
              the Offerings. Discloser gives Recipient right to obtain, utilize,
              retain, and transmit Personal Data for the exclusive purpose of
              delivering or administering the services.
            </p>
          </li>
          <li data-list-text={2.}>
            <p style={{paddingTop: '8pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify'}}>
              Upon becoming aware of any confirmed unauthorized or unlawful breach
              of security that leads to the destruction, loss, alteration, or
              unauthorized disclosure of or access to Discloser Personal Data,
              Recipient shall notify Discloser.
            </p>
          </li>
        </ol>
        <p className="s2" style={{paddingTop: '7pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left'}}>
          SECTION C
        </p>
        <h1 style={{paddingTop: '8pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left'}}>
          COMPLIANCE WITH PRIVACY AND INFORMATION SECURITY REQUIREMENTS<span className="p">.</span>
        </h1>
        <ol id="l3">
          <li data-list-text={1.}>
            <p style={{paddingTop: '7pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify'}}>
              If relevant, the recipient must adhere to all applicable privacy and
              confidentiality laws, as well as the EU-US Privacy Shield Framework
              established by the US Department of Commerce for the capture,
              utilization, and storage of Personal Data from the European Economic
              Area. In addition, Recipient must adhere to the United States-Swiss
              Safe Harbor framework, or its alternative, as laid forth by the United
              States Department of Commerce for the acquisition, processing, and
              storage of Personal Data from Switzerland, if applicable. The CCPA and
              TCPA are examples of privacy and security laws.
            </p>
          </li>
          <li data-list-text={2.}>
            <p style={{paddingTop: '8pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify'}}>
              Recipient shall ensure appropriate technical and organizational
              security measures directly correlated with the sensitivity of the
              Personal Data processed on Discloser's behalf, which are intended
              to shield the safety, trustworthiness, and privacy of such Personal
              Data, as well as prevent unauthorized or malicious destruction,
              damage, modification, and unauthorized disclosure or access.
            </p>
          </li>
          <li data-list-text={3.}>
            <p style={{paddingTop: '8pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify'}}>
              Access; Contacts - Only Members who have a cogent reason to access
              Personal Data in order to offer, support, and enhance the Products and
              Services shall have access to Personal Data.
            </p>
          </li>
        </ol>
        <p className="s2" style={{paddingTop: '7pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left'}}>
          SECTION D
        </p>
        <h1 style={{paddingTop: '8pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left'}}>
          RESPONSE<span className="p">. TO </span>SECURITY INCIDENT
        </h1>
        <p style={{paddingTop: '7pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left'}}>
          Recipient shall, In the event Recipient discovers a Security incident;
        </p>
        <ol id="l4">
          <li data-list-text={1.}>
            <p style={{paddingTop: '8pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify'}}>
              Notify discloser of the discovery of the security Incident. Such
              notice shall summarize the known circumstances of the Security
              Incident and the corrective action taken or to be taken by Recipient.
            </p>
          </li>
          <li data-list-text={2.}>
            <p style={{paddingTop: '7pt', paddingLeft: '21pt', textIndent: '-16pt', textAlign: 'justify'}}>
              Conduct an investigation of the circumstances of the Security
              Incident.
            </p>
          </li>
          <li data-list-text={3.}>
            <p style={{paddingTop: '3pt', paddingLeft: '21pt', textIndent: '-16pt', textAlign: 'left'}}>
              Use commercially reasonable efforts to remediate the Security
              Incident.
            </p>
          </li>
          <li data-list-text={4.}>
            <p style={{paddingTop: '8pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left'}}>
              Use commercially reasonable efforts to communicate and cooperate with
              Discloser concerning its response to the Security Incident.
            </p>
          </li>
          <li data-list-text={5.}>
            <p style={{paddingTop: '8pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left'}}>
              Allow Discloser to run a security audit to assess whether the Security
              Incident has been resolved at Recipient’s sole expense.
            </p>
          </li>
        </ol>
        <p className="s2" style={{paddingTop: '7pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left'}}>
          SECTION E
        </p>
        <h1 style={{paddingTop: '8pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left'}}>
          DISCLOSER OBLIGATIONS<span className="p">.</span>
        </h1>
        <p style={{paddingTop: '8pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify'}}>
          Discloser acknowledges that it has a legal basis for allowing Recipient to
          process Personal Data, and/or that Discloser has made such disclosures and
          acquired such permit and approvals for Recipient to lawfully treat
          Personal Data.
        </p>
        <p className="s2" style={{paddingTop: '8pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left'}}>
          SECTION F
        </p>
        <h1 style={{paddingTop: '7pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'left'}}>
          RESTRICTED AREAS.
        </h1>
        <p style={{paddingTop: '8pt', paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify'}}>
          Intending Merchants/Sellers who reside in California and the European
          Economic Area are presently not eligible to utilize Bouk platforms and
          services. You accept to only use Bouk Platforms and Services in the
          areas/regions/states/locations where Bouk operates. If you live in
          California or the European Economic Area ("EEA"), please, kindly
          do not download/use/access the Bouk Platform or Services, neither should
          you give nor enable Bouk receive personal information from you a
          California resident or EEA citizen.
        </p>
    </div>
  )
}

export default BoukMerchantsSecurityofDataandPrivacyPolicy
